import { LOGIN, LOGOUT, RENEW, UPDATE } from '../actions/auth.actions';
import { SET_AUTH, PURGE_AUTH, TRY_AUTH, SET_USER_ROLE } from '../mutations/auth.mutations';
import { SET_ERROR } from '../mutations/common.mutations';
import AuthService from '@/common/services/auth.service';
import StorageService from '@/common/services/storage.service';
import { BACK_TO_ADMIN, LOGIN_AS_STUDENT, UPDATE_PASSWORD, URL_LOGIN } from '@/store/actions/auth.actions';
import { SHOW_NOTIFICATION } from '@/store/actions/app.actions';
import { getError } from '@/common/services/http.service';
import { modules } from '@/common/utils/modules';
import { LOG_ACTIVITY } from '@/store/actions/activity.actions';
import ActivityService from '@/common/services/activity.service';

const state = {
  pending: false,
  errors: [],
  user: null,
  userRole: 0,
  isAuthenticated: false
};

const actions = {
  [LOGIN](context, credentials) {
    return new Promise((resolve, reject) => {
      context.commit(TRY_AUTH);

      AuthService.login(credentials)
        .then(data => {
          context.commit(SET_AUTH, data.user);
          StorageService.setItem(StorageService.KEYS.ACCESS_TOKEN, data.token);
          resolve(data);
        })
        .catch(response => {
          context.commit(SET_ERROR, getError(response));
          if (response.status !== 403) {
            context.dispatch(SHOW_NOTIFICATION, {type: 'error', message: getError(response)}, { root: true });
          }
          reject(response);
        });
    });
  },
  [URL_LOGIN](context, hash) {
    return new Promise((resolve, reject) => {
      context.commit(TRY_AUTH);

      AuthService.urlLogin(hash)
        .then(data => {
          context.commit(SET_AUTH, data.user);
          StorageService.setItem(StorageService.KEYS.ACCESS_TOKEN, data.token);
          resolve(data);
        })
        .catch(response => {
          context.commit(SET_ERROR, getError(response));
          if (response.status !== 403) {
            context.dispatch(SHOW_NOTIFICATION, {type: 'error', message: getError(response)}, { root: true });
          }
          reject(response);
        });
    });
  },
  [BACK_TO_ADMIN](context, credentials) {
    return new Promise((resolve, reject) => {
      context.commit(TRY_AUTH);

      AuthService.login(credentials)
          .then(data => {
            context.commit(SET_AUTH, data.user);
            StorageService.setItem(StorageService.KEYS.ACCESS_TOKEN, data.token);
            resolve(data);
          })
          .catch(response => {
            context.commit(SET_ERROR, getError(response));
            reject(response);
          });
    });
  },
  [LOGIN_AS_STUDENT](context) {
    return new Promise((resolve, reject) => {
      context.commit(TRY_AUTH);

      // prevent Student Only users from logging in as Students
      if (AuthService.role() === AuthService.ROLES.STUDENT_ONLY) {
        context.state.pending = false;
        resolve();
      } else {
        const moduleId = Object.keys(modules).find(key => modules[key] === process.env.VUE_APP_MODULE);
        AuthService.loginAsStudent()
          .then(data => {
            context.commit(SET_AUTH, data.user);
            context.dispatch(LOG_ACTIVITY, {
              activityType: ActivityService.ACTIVITY_TYPES.AUTH.STUDENT_LOGIN,
              activityData: { 
                userId: data.user.id,
                moduleId: parseInt(moduleId)
              },
            });
            StorageService.setItem(StorageService.KEYS.ACCESS_TOKEN, data.token);
            resolve(data);
          })
          .catch(response => {
            context.commit(SET_ERROR, getError(response));
            reject(response);
          });
      }
    });
  },
  [RENEW](context) {
    return new Promise((resolve, reject) => {
      context.commit(TRY_AUTH);

      AuthService.renew()
        .then(data => {
          context.commit(SET_AUTH, data.user);
          StorageService.setItem(StorageService.KEYS.ACCESS_TOKEN, data.token);
          resolve(data);
        })
        .catch(response => {
          context.commit(SET_ERROR, getError(response));
          context.dispatch(SHOW_NOTIFICATION, {type: 'error', message: getError(response)}, { root: true });
          context.dispatch(LOGOUT);
          reject(response)
        });
    });
  },
  [LOGOUT](context) {
    AuthService.logout();
    context.commit(PURGE_AUTH);
  },
  [UPDATE](context, payload) {
    return new Promise((resolve, reject) => {
      context.commit(TRY_AUTH);

      AuthService.update(payload)
        .then(data => {
          context.commit(SET_AUTH, data.user);
          resolve(data);
        })
        .catch(response => {
          context.commit(SET_ERROR, getError(response));
          context.dispatch(SHOW_NOTIFICATION, {type: 'error', message: getError(response)}, { root: true });
          reject(response)
        });
    });
  },
  [UPDATE_PASSWORD](context, newPassword) {
    return new Promise((resolve, reject) => {
      context.commit(TRY_AUTH);

      AuthService.updatePassword(newPassword)
        .then(data => {
          context.commit(SET_AUTH, data.user);
          resolve(data);
        })
        .catch(response => {
          context.commit(SET_ERROR, getError(response));
          context.dispatch(SHOW_NOTIFICATION, {type: 'error', message: getError(response)}, { root: true });
          reject(response);
        })
    })

  }
};

const mutations = {
  [TRY_AUTH](state) {
    state.pending = true;
    state.errors = [];
  },
  [SET_ERROR](state, errors) {
    state.pending = false;
    state.errors = errors;
  },
  [SET_AUTH](state, user) {
    state.pending = false;
    state.isAuthenticated = true;
    state.errors = [];
    state.user = user;
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = null;
    state.errors = [];
  },
  [SET_USER_ROLE](state, role) {
    state.userRole = role;
  }
};

const getters = {
  isStudentOnlyUser(state) {
    return state.userRole === AuthService.ROLES.STUDENT_ONLY;
  },
  currentUser(state) {
    return state.user;
  },
  authErrors(state) {
    return state.errors;
  },
  authPending(state) {
    return state.pending;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
